var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-border-b gl-flex gl-justify-between gl-bg-subtle"},[_c('div'),_vm._v(" "),_c('blame-preferences',{attrs:{"has-revs-file":_vm.hasRevsFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }